<script lang="ts">
import { MyFitnessStores } from "./stores";
import { init as init_locale, getLocaleFromNavigator } from 'svelte-i18n';
import { _, addMessages } from 'svelte-i18n'
import en from '../lang/en.json'
import { onDestroy } from "svelte";
import type Pusher from "pusher-js";
import route from "../Util/routes";
import { getRequest } from "../Util/utils";
import RestartAccountPrompt from "./RestartAccountPrompt.svelte";
export let userParams, trainingAdvice, trainingPlan, cal_settings;
export let loggedIn = true;
export let trickleActive = true;
export let loadSessions = false;
// Offered once after logging in when the recent riding is too little to plan from (AccountRestartController::loginPrompt)
export let restartPrompt = null;

// TODO: migrate away from global pusher variables and init channels here instead.
const channel = Xert._userChannel as PusherTypes.Channel;

const getTrainingAdviceURL = route('UserController@getTrainingAdvisor');


// Collection of globals shared by other components.
let stores = new MyFitnessStores(userParams, trainingAdvice, cal_settings, trainingPlan, loadSessions, loggedIn, trickleActive);
let { sessionUpdates, trainingAdviceUpdatedAt } = stores;

export function getStores() {
    return stores;
}

init_locale({
    fallbackLocale: 'en',
    initialLocale: getLocaleFromNavigator(),
})

addMessages('en', en);
addMessages('en-US', en);

let prevEventDate: Date|null = null

// TODO: Move to stores.ts?
const callback = async (event) => {
    // TODO: move enableAta, etc. to svelte code.
    // Currently still in my_fitness.js
    if (NProgress != null)
        NProgress.done();
    if (Xert.MyFitness != null)
        Xert.MyFitness.enableAta();

    // TODO: Is this OK here at the start of the function? It used to be at the end.
    if (event.event == 'trickle_complete')
        stores.trickleActive.set(false);

    // let timestamp = new Date(event.timestamp)
    let timestamp = new Date(event.created_at)

    // Training advice already up to date.
    if (timestamp < $trainingAdviceUpdatedAt) return
    // Events arrived out of order, later event already processed.
    if (prevEventDate && timestamp < prevEventDate) return

    prevEventDate = timestamp

    const result = await fetch(getTrainingAdviceURL, {
        ...getRequest()
    }).then((r)=>r.json());

    if (result.training_advice) {
        // Keep track of date when training advice was generated.
        stores.trainingAdviceUpdatedAt.set(new Date(result.training_advice.timestamp));
        stores.trainingAdvice.set(result.training_advice);
    }
    if (result.training_plan) {
        stores.trainingPlan.set(result.training_plan);
    }
};
const callbackTrickleStart = (event) => {
    stores.trickleActive.set(true);
    if (NProgress != null)
        NProgress.start();
    if (Xert.MyFitness != null)
        Xert.MyFitness.disableAta();
};
const callbackRecommendedTraining = (event) => {
    stores.recommendedTrainingUpdatedAt.set(new Date(event.created_at));
}
// TODO: Maybe compare unique id to event?
// For example, if id matches, that means event was created by this instances,
// otherwise it was from a different tab/browser/computer etc.

// TODO: Do we need activity_complete events? Calendar also handles those.
if (loggedIn) {
    const events = [
        'schedule_activity_complete',
        'modify_activity_complete',
        'delete_activity_complete', // Delete activity.
        'upload_activity_complete', // New activity, so its XSS has entered the training load.
        'trickle_complete',
        'progression_refreshed', // When ir params changed in profile settings.
        'sessions', // When you leave session.
    ];
    for(const event of events) {
        channel.bind(event, callback);
    }
    channel.bind('trickle_start', callbackTrickleStart);
    channel.bind('recommended_training', callbackRecommendedTraining);
    channel.bind('progression_refreshed', callbackRecommendedTraining);

    onDestroy(()=>{
        for(const event of events) {
            channel.unbind(event, callback);
        }
        channel.unbind('trickle_start', callbackTrickleStart);
        channel.unbind('recommended_training', callbackRecommendedTraining);
        channel.unbind('progression_refreshed', callbackRecommendedTraining);
    })
}
$: if ($sessionUpdates) {
    callbackRecommendedTraining({created_at: new Date()});
}

</script>

{#if restartPrompt}
    <RestartAccountPrompt prompt={restartPrompt} />
{/if}
